/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activation_Success_ToastInputs */

const en_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation was successful. Please restart the program.`)
};

const fr_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation reussie. Veuillez redemarrer le programme.`)
};

const de_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aktivierung war erfolgreich. Bitte starten Sie das Programm neu.`)
};

const it_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivazione avvenuta con successo. Riavviare il programma.`)
};

const ru_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активация прошла успешно. Пожалуйста, перезапустите программу.`)
};

const es_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La activación se realizó correctamente. Reinicie el programa.`)
};

const zh_cn2_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活成功。请重启程序。`)
};

const ja_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーションに成功しました。プログラムを再起動してください。`)
};

const hi_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रियण सफल रहा। कृपया प्रोग्राम को पुनः आरंभ करें।`)
};

const pt_pt2_login_offline_activation_success_toast = /** @type {(inputs: Login_Offline_Activation_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ativação foi bem-sucedida. Reinicie o programa.`)
};

/**
* | output |
* | --- |
* | "Activation was successful. Please restart the program." |
*
* @param {Login_Offline_Activation_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_success_toast = /** @type {((inputs?: Login_Offline_Activation_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_activation_success_toast(inputs)
	if (locale === "de") return de_login_offline_activation_success_toast(inputs)
	if (locale === "it") return it_login_offline_activation_success_toast(inputs)
	if (locale === "ru") return ru_login_offline_activation_success_toast(inputs)
	if (locale === "es") return es_login_offline_activation_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_activation_success_toast(inputs)
	if (locale === "ja") return ja_login_offline_activation_success_toast(inputs)
	if (locale === "hi") return hi_login_offline_activation_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_activation_success_toast(inputs)
	return en_login_offline_activation_success_toast(inputs)
});